module.exports = __webpack_public_path__ + "static/img/quiz_center.2e0b338.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/quiz_center.png
// module id = v/5X
// module chunks = 1